import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./assets/App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import NavBar from "./Components/NavBar";
import Home from "./Components/Home";
import Draft from "./Components/Draft";
import Mailbox from "./Components/Mailbox";
import Profile from "./Components/Profile";
import About from "./Components/About";
import Send from "./Components/Send";
import Letter from "./Components/Letter";

function App() {
  return (
    <div className="wrapper">
      {/* <NavBar /> */}

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Draft" element={<Draft />} />
          <Route path="/Mailbox" element={<Mailbox />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/About" element={<About />} />
          <Route path="/Send" element={<Send />} />
          <Route path="/Letter" element={<Letter />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

/*
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;*/
